import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from "../shared/abstract-boxes";

export function TextMatchBoxViewConstructor(services) {
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editTextMatchController',
    editElementModalTemplate: require('./edit-text-match.modal.html'),



    angularTemplate: '<div class="text-match" translate-once="parameters/quick_replies/details/graph/text-match/default-description"></div>',

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);




      this.model.on('change', () => {
        this.angularScope.elementData.references = {
          matchBoxId: null,
          notMatchBoxId: null
        };

        this.model.getEmbeddedCells().forEach(child => {
          if (child.get('elementData')) {
            const { type } = child.get('elementData');
            if (type === 'match') {
              this.angularScope.elementData.references.matchBoxId = child.id;
            } else if (type === 'notMatch') {
              this.angularScope.elementData.references.notMatchBoxId = child.id;
            }
          }
        });

        this.model.set('elementData', this.angularScope.elementData);
      })




      setTimeout(() => this.updateValidity(), 200);
    },

    createOutput: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData) {
      return new joint.shapes.html.TextMatchAnswerExit({ id, position, size, elementData });
    },

    isChildAlwaysLast: function (child) {
      return 'html.UserInput' === child.get('type');
    },

    paddingTop: function () {
      return this.heightOfHTMLContent();
    },

    afterEditElement: function () {
      this.updateValidity();
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        const { beforeMatch, afterMatch, variable } = this.angularScope.elementData;
        this.model.setBoxValid(beforeMatch && afterMatch && variable);

        // The watch mecanism to refresh the elementData model is not triggered when the change comes from the children.       
        this.model.set('elementData', this.angularScope.elementData);
      }

    },
  });
}
